import React from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Divider,
  Box,
  styled,
  Chip,
} from '@mui/material'
import DateFormatter from '@/utilities/date-formatter'
import { AreaData } from '@/utilities/types/table'

interface ViewAreaModalProps {
  open: boolean
  onClose: () => void
  data: AreaData | null
}

export const ModalContainer = styled(Box)({
  transform: 'translateZ(0)',
  backfaceVisibility: 'hidden',
  height: `calc(100% - 120px)`,
  flex: 1,
  overflow: 'auto',
  position: 'relative',
  scrollbarWidth: 'thin',
  scrollbarColor: '#888 #f1f1f1',
  '&::-webkit-scrollbar': {
    width: '8px',
    height: '8px',
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: '#f1f1f1',
    borderRadius: '4px',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#888',
    borderRadius: '4px',
    '&:hover': {
      backgroundColor: '#555',
    },
  },
})

const ViewAreaModal = ({ open, onClose, data }: ViewAreaModalProps) => {
  if (!data) return null
  console.log('look at this Yey', data.branches)
  const fields = [
    { label: 'ID', value: data.id },
    // { label: 'Parent Area', value: data.parentArea || '-' },
    { label: 'Area Code', value: data.code },
    { label: 'Area Name', value: data.name },
    {
      label: 'Branches',
      value: (
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: 1,
            mt: 0.5,
          }}
        >
          {data.branches.length > 0
            ? data.branches.map((branch) => (
                <Chip
                  key={branch.id}
                  label={`${branch.dealerName} - ${branch.name}`}
                  size="small"
                  variant="outlined"
                />
              ))
            : '-'}
        </Box>
      ),
    },
    // {
    //   label: 'Provinces',
    //   value:
    //     data.provinceList.length > 0
    //       ? data.provinceList.map((province) => province.name).join(', ')
    //       : '-',
    // },
    {
      label: 'Created Date',
      value: <DateFormatter dateString={data.dateCreated} />,
    },
    {
      label: 'Modified Date',
      value: <DateFormatter dateString={data.dateModified} />,
    },
  ]

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Area Details</DialogTitle>
      <DialogContent>
        <Box container spacing={2} sx={{ mt: 1 }}>
          {fields.map((field, index) => (
            <Box key={index} sx={{ mb: 2 }}>
              <Typography
                variant="caption"
                component="div"
                sx={{ color: 'text.secondary', mb: 0.5 }}
              >
                {field.label}
              </Typography>
              <Typography variant="body2" component="div">
                {field.value}
              </Typography>
              {index < fields.length - 1 && <Divider sx={{ mt: 2 }} />}
            </Box>
          ))}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ViewAreaModal
